import { render } from "./SubscriptionViewPage.vue?vue&type=template&id=5ca12b3a"
import script from "./SubscriptionViewPage.vue?vue&type=script&lang=ts"
export * from "./SubscriptionViewPage.vue?vue&type=script&lang=ts"

import "./SubscriptionViewPage.vue?vue&type=style&index=0&id=5ca12b3a&lang=scss"
script.render = render

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip,QInput,QTable,QTh,QTr,QTd});
